import React from "react"
import nl2br from "../../../utils/nl2br"

export default ({ introText, introTitle }) => {
  return (
    <>
      <div className="row">
        <div className="col-md-10">
          <h3 className={"mb-4 pb-3"}>{introTitle}</h3>
        </div>
        <div className={"col-md-12"}>
          <p className={"my-0"}>{nl2br(introText)}</p>
        </div>
      </div>
    </>
  )
}
